import client from './main-client';

export const getMarketsApi = (params) => client()
  .get('/options-markets', { params });
